// src/admin/FormEditor/components/DraggableList.jsx
// A reusable component that creates a drag-and-drop list using framer-motion
// Props:
// - items: Array of items to be rendered
// - onReorder: Callback function when items are reordered
// - renderItem: Render function for each item
// Features:
// - Vertical dragging only (axis="y")
// - Visual feedback during drag (scale effect)
// - Grab cursor indication

import { Reorder } from 'framer-motion';
import { useState } from 'react';

export const DraggableList = ({ items, onReorder, renderItem }) => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <Reorder.Group
      axis="y"
      values={items}
      onReorder={onReorder}
      className="space-y-4"
    >
      {items?.map((item, index) => (
        <Reorder.Item
          key={item.object_id}
          value={item}
          dragListener={true}
          className="cursor-grab active:cursor-grabbing"
          whileDrag={{ scale: 1.01 }}
          transition={{ duration: 0.1 }}
          onDragStart={() => setIsDragging(true)}
          onDragEnd={() => {
            // Add a small delay to prevent the click event from firing
            setTimeout(() => setIsDragging(false), 100);
          }}
          onClick={(e) => {
            // Prevent click events during and immediately after dragging
            if (isDragging) {
              e.stopPropagation();
            }
          }}
        >
          {renderItem(item, index)}
        </Reorder.Item>
      ))}
    </Reorder.Group>
  );
};